/* BESOCKS · barra de envio gratis dentro del carrito lateral (mismo motivo de "ruta" que la ficha). Textos en es/en/fr/de/it y umbral por zona: Espana 29 €, Europa 59 €, resto sin envio gratis */
(function () {
  if (window.__bsCartProgress) return;
  window.__bsCartProgress = true;

  var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  if (['es', 'en', 'fr', 'de', 'it'].indexOf(lang) < 0) lang = 'en';
  var EU = ['BE', 'FR', 'DE', 'IT', 'NL', 'PT', 'DK', 'AT', 'PL', 'HR', 'SE'];
  var country = ((window.Shopify && window.Shopify.country) || 'ES').toUpperCase();
  var zone = country === 'ES' ? 'ES' : EU.indexOf(country) > -1 ? 'EU' : 'INT';
  var THRESHOLD = zone === 'EU' ? 5900 : 2900; /* 29 € Espana / 59 € Europa, en centimos */
  var last = null;

  var T = {
    es: { from: 'Envío gratis desde', ES: 'Península', EU: 'Europa', unlocked: 'Envío gratis desbloqueado', pre: 'Te faltan ', post: 'para el envío gratis', aria: 'Progreso hacia el envío gratis' },
    en: { from: 'Free shipping from', ES: 'Mainland Spain', EU: 'Europe', unlocked: 'Free shipping unlocked', pre: '', post: 'away from free shipping', aria: 'Progress towards free shipping' },
    fr: { from: 'Livraison gratuite dès', ES: 'Espagne continentale', EU: 'Europe', unlocked: 'Livraison gratuite débloquée', pre: 'Plus que ', post: 'pour la livraison gratuite', aria: 'Progression vers la livraison gratuite' },
    de: { from: 'Kostenloser Versand ab', ES: 'Festland Spanien', EU: 'Europa', unlocked: 'Kostenloser Versand freigeschaltet', pre: 'Noch ', post: 'bis zum kostenlosen Versand', aria: 'Fortschritt zum kostenlosen Versand' },
    it: { from: 'Spedizione gratuita da', ES: 'Spagna peninsulare', EU: 'Europa', unlocked: 'Spedizione gratuita sbloccata', pre: 'Ti mancano ', post: 'per la spedizione gratuita', aria: 'Avanzamento verso la spedizione gratuita' }
  }[lang];

  function money(c, cur) {
    try { return new Intl.NumberFormat(lang === 'en' ? 'en-GB' : lang, { style: 'currency', currency: cur || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' €'; }
  }

  function html(cart) {
    if (zone === 'INT') return null; /* fuera de la UE no hay envio gratis */
    var total = cart.total_price, rem = Math.max(0, THRESHOLD - total);
    var pct = Math.min(100, Math.round((total * 100) / THRESHOLD));
    var region = T[zone];
    var msg = !cart.item_count
      ? '<strong>' + T.from + ' ' + money(THRESHOLD, cart.currency).replace(/[.,]00(?=\D*$)/, '') + '</strong> <span>· ' + region + '</span>'
      : rem === 0
        ? '<strong>' + T.unlocked + '</strong> <span>· ' + region + '</span>'
        : '<strong>' + T.pre + money(rem, cart.currency) + '</strong> <span>' + T.post + '</span>';
    return { free: !!cart.item_count && rem === 0, pct: pct, msg: msg };
  }

  function paint() {
    if (!last) return; /* también con el carrito vacío */
    var host = document.querySelector('#cart-drawer .cart-drawer__content');
    if (!host) return;
    var el = host.querySelector(':scope > .bs-cart-progress');
    var d = html(last);
    if (!d) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'bs-cart-progress';
      el.innerHTML = '<p></p><span class="bs-cart-progress__route" role="progressbar" aria-label="' + T.aria + '" aria-valuemin="0" aria-valuemax="100"><span></span></span>';
      host.insertBefore(el, host.firstChild);
    }
    el.classList.toggle('is-free', d.free);
    el.querySelector('p').innerHTML = d.msg;
    var r = el.querySelector('.bs-cart-progress__route');
    r.style.setProperty('--p', d.pct);
    r.setAttribute('aria-valuenow', d.pct);
  }

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { last = c; paint(); })
      .catch(function () {});
  }

  // Aviso cuando cambia el carrito (mismo mecanismo que el bloque de la ficha)
  if (!window.__bsCartWatch) {
    window.__bsCartWatch = true;
    var ping = function () { document.dispatchEvent(new CustomEvent('bs:cart-changed')); };
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(ping, 50); }).catch(function () {});
      return p;
    };
    ['cart:update', 'cart:updated', 'cart:change'].forEach(function (e) { document.addEventListener(e, ping); });
  }
  document.addEventListener('bs:cart-changed', refresh);

  // Horizon vuelve a pintar el carrito: si la barra desaparece, se repone
  function watch() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      var host = drawer.querySelector('.cart-drawer__content');
      if (host && !host.querySelector(':scope > .bs-cart-progress')) paint();
    }).observe(drawer, { childList: true, subtree: true });
  }

  var css = document.createElement('style');
  css.textContent =
    '.bs-cart-progress{padding:4px var(--cart-drawer-padding,20px) 18px;display:grid;gap:10px;font-size:.8125rem}' +
    '.bs-cart-progress p{margin:0}.bs-cart-progress strong{font-family:var(--font-heading--family)}.bs-cart-progress p span{color:#6b6b6b}' +
    '.bs-cart-progress__route{position:relative;display:block;height:8px;background:linear-gradient(#d6d6d6,#d6d6d6) center/100% 1px no-repeat}' +
    '.bs-cart-progress__route::before,.bs-cart-progress__route::after{content:"";position:absolute;top:50%;width:6px;height:6px;margin-top:-3px;border-radius:50%}' +
    '.bs-cart-progress__route::before{left:0;background:#000}.bs-cart-progress__route::after{right:0;background:#d6d6d6}' +
    '.bs-cart-progress__route>span{position:absolute;left:0;top:50%;height:1px;margin-top:-.5px;width:calc(var(--p,0)*1%);background:#000;transition:width .6s cubic-bezier(.2,.8,.2,1)}' +
    '.bs-cart-progress__route>span::after{content:"";position:absolute;right:-4px;top:-3.5px;width:8px;height:8px;border-radius:50%;background:#000}' +
    '.bs-cart-progress.is-free .bs-cart-progress__route::after,.bs-cart-progress.is-free .bs-cart-progress__route>span::after{background:#00FA32}' +
    /* carrito vacio: la barra arriba, a todo el ancho, aunque el resto vaya centrado */
    '.cart-drawer--empty .bs-cart-progress,cart-drawer-component:not(:has(.cart-form)) .bs-cart-progress{align-self:stretch;text-align:left;padding-top:0}' +
    '.cart-drawer--empty .cart-drawer__content:has(> .bs-cart-progress),cart-drawer-component:not(:has(.cart-form)) .cart-drawer__content:has(> .bs-cart-progress){justify-content:flex-start}' +
    '.cart-drawer--empty .bs-cart-progress + *,cart-drawer-component:not(:has(.cart-form)) .bs-cart-progress + *{margin-top:auto}' +
    '.cart-drawer--empty .cart-drawer__content:has(> .bs-cart-progress) > :last-child,cart-drawer-component:not(:has(.cart-form)) .cart-drawer__content:has(> .bs-cart-progress) > :last-child{margin-bottom:auto}';
  document.head.appendChild(css);

  function init() { watch(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
